import React from 'react';
import './App.css';
import {FaHeart, FaFrownOpen, FaFemale, FaVaadin, FaHeartbeat, FaPrescription, FaPlusSquare} from 'react-icons/fa'
import Axios from 'axios'
import withStyles from 'react-jss'



const styles = {
  tileGroup: {
  
    margin: '5px',
  },
  tileIcon: {
    fontSize: '2em'
  },
  tile: {
    border: '1px solid #E22A79',
    textAlign: 'center',
    cursor: 'pointer',
    borderRadius: '10px',
    minHeight: '100px',
    color: '#E22A79',
    margin: '5px',
    overflowWrap: 'break-word'
  },
  selectedTile: {
    border: '1px solid #E22A79',
    textAlign: 'center',
    cursor: 'pointer',
    borderRadius: '10px',
    minHeight: '100px',
    color: '#FFFFFF',
    background: '#E22A79',
    margin: '5px',
    overflowWrap: 'break-word'
  }
}

class App extends React.Component{

constructor(props){
  super(props);
  this.state = {
    email: '',
    name: '',
    phone: '',
    products:[],
    message: '',
    problems: {
      'anxiety': false,
      'endometriosis': false,
      'menstrual-pain': false,
      'inflammation': false,
      'uterine-fibroids': false,
      'pain-relief': false
    },
    postSuccess: false,
    postFailure: false,
    postEmailFailure: false,
    postEmailSuccess: false
  }
}

handleChange = (event) => {
  this.setState({
    [event.currentTarget.id]: event.currentTarget.value
  })
}
handleSelectChange = (event) => {
  this.setState({
    products:[].slice.call(event.target.selectedOptions).map(o => {
        return o.value;
    })
});
}

handleTileClick = (event) => {
  var target = event.currentTarget.id;
  //first clone the object
  var newObj = Object.assign({}, this.state.problems);
  //now switch the state in new object
  newObj[target] = !newObj[target];
  //now update component state
  this.setState({problems: newObj})
}

stringifyProblems = () => {
  var obj = Object.assign({}, this.state.problems)
  var results = [];
  for(var property in obj){
    if(obj[property] === true){
      results.push(property)
    }
  }
  return results.toString()
}

enterGiveaway = () => {
  Axios({
    url: 'https://api.clickficks.com/femnitude/newContactUs',
    method: 'post',
    data: {
      name: this.state.name,
      email: this.state.email,
      products: this.stringifyProblems(),
      phone: this.state.phone,
      message: this.state.message
    }
  })
  .then(res=>{
    console.log('Submitted');
    this.setState({
      postSuccess: true
    })
  })
  .catch(err=>{
    console.log('Submission failed! ', err);
    this.setState({
      postFailure: true
    })
  })
}

submitEmail = () => {
  Axios({
    method: 'post',
    url: 'https://api.clickficks.com/femnitude/newContactUs',
    data: {
      email: this.state.email
    }
  })
  .then(res=> {
    console.log('Submitted');
    this.setState({
      postEmailSuccess: true
    })
  })
  .catch(err=>{
    console.log(err);
    this.setState({
      postEmailFailure: true
    })
  })
}
render() {
  const {classes} = this.props;
  return (
    <div className="App" style={{backgroundImage: `url('img/background.png')`}}>
      <div>
  {/* *** LOADING *** */}
  <div id="loading">
    <div className="loader">
      <div className="loader__figure" />
      <p className="loader__label">Loading</p>
    </div>
  </div>
  {/* *** / LOADING *** */}
  {/* *** Menu icon for opening/closing the menu on small screen *** */}
  <button id="small-screen-menu">
    <span className="custom-menu" />
  </button>


  {/* *** / Menu icon *** */}

  {/*<!-- *** Liquid effect *** -->*/}
 




  {/* *** LEFT SIDE *** */}
  <div id="left-part">
    {/* *** LOGO *** */}
    {/* Line 1773 in js/jquery.fullpage.js is the place to select the anchor scrolling to the section of your choice */}
    <img src="img/logo.svg" alt="Femnitude Logo" className="brand-logo" />
    <div className="content-inside">
      {/* *** TEXT TITLE *** */}
        <h1 style={{transform: 'rotate(-10deg)', fontFamily:'cursive', fontWeight: '600'}}>
          Get Excited!
        </h1>
        <br/>
        <h1 style={{textAlign:'center', fontWeight: '600'}}>
          Our CBD Subscription<br/>Boxes <br />
        </h1>
        <br/>
        <h1 style={{fontSize: '5rem', textAlign: 'center', fontWeight: '600'}}>
          Are Coming Soon!
        </h1>
      {/* *** COUNTDOWN TITLE *** */}
      {/* Set your date at the bottom of js/jquery.countdown.js */}
      {/* <h1>
					Our Destiny starts in <br>
					<span id="getting-started"></span>
				</h1> */}
      <div className="text">
        <p>
          {/*We aim to dispel the negative assumptions surrounding CBD and bring light to the many alternative uses for it in women's health!*/}
        </p>
        <br />
        <a id="show-news-form" className="light-btn colored">
          <span id="first-text">I'm Interested</span>
          <span id="second-text">Get notified</span> {/* On this span, it's important to use a text smaller or equal than the first one (here: Weekly Newsletter) to avoid any troubles */}
        </a>
        {/* Line 1789 in js/jquery.fullpage.js is the place to select the anchor scrolling to the section of your choice */}
        <a id="button-more" className="light-btn">More Info
          <span className="ask-to-scroll">
            <span className="arrow"><span /><span /></span>
            <span className="arrow"><span /><span /></span>
            <span className="arrow"><span /><span /></span>
          </span>
        </a>
        <div className="clear" />
        {/* *** Newsletter Form *** */}
        <div id="subscribe" className="animated-quick fadeOutDown display-none">
          <button id="hide-newsletter" className="animated-quick display-none"><i className="fa fa-close" /></button>
          <form action="php/notify-me.php" id="notifyMe" method="POST">
            <div className="form-group">
              <div className="controls">
                {/* Field  */}
                <input type="text" id="email" name="email" placeholder="Enter email for updates..." onChange={this.handleChange} value={this.state.email}  className="form-control email srequiredField" />
                {/* Button */}
                <button type='button' id="submit-form" className="btn btn-lg submit" onClick={this.submitEmail}>Subscribe now!</button>
                <div className="clear" />
              </div>
            </div>
          </form>
          <p className="spam-news"><i className="fa fa-lock" /> We hate spam just as much as you do. Your email will not be shared.</p>
          {this.state.postEmailSuccess ?
            <span style={{color: 'green'}}>
              We will keep you in the loop about Femnitude! Please fill out the form at the bottom of the page to be entered into our giveaway!
            </span> : <span/>
          }
          {this.state.postEmailFailure ?
            <span style={{color: 'red'}}>
              Sorry we were unable to post your email! Please send an email to <a href='mailto:femnitude@gmail.com' style={{color: 'black'}}>femnitude@gmail.com</a> to stay in the loop on updates for Femnitude!
            </span> : <span/>
          }
        </div>
        {/* *** /. Newsletter Form *** */}
      </div>
    </div>
    {/* *** Social Media list *** */}
    <div id="social-nav">
      <ul>
        {/* Facebook */}
        <li>
          <a href="https://www.facebook.com/Femnitude" target="_blank"><i className="fa fa-facebook" /></a>
        </li>
        {/* Twitter */}
        <li>
          <a href="https://twitter.com/femnitude" target="_blank"><i className="fa fa-twitter" /></a>
        </li>
        {/* Linkedin */}
        {/*
          <li>
            <a href="#" target="_blank"><i className="fa fa-linkedin" /></a>
          </li>
        */}
        {/* Instagram */}
        <li>
          <a href="https://www.instagram.com/femnitude/" target="_blank"><i className="fa fa-instagram" /></a>
        </li>
      </ul>
    </div>
  </div>
  {/* *** / LEFT SIDE *** */}
  {/* *** RIGHT SIDE - Fullpage sections *** */}
  <div id="fullpage">
    {/* +++ START - Home +++ */}
    <div className="section" id="section0">
      {/* *** E M P T Y *** */}
    </div>
    {/* +++ END - Home +++ */}
    {/* +++ START - About +++ */}
    <div className="section" id="section1">
      <section id="about" className="content-inside-section">
        <div className="row row-no-margin">
          <div className="left-center-text">
            <div className="left-center-part">
              <span className="section-name">About us</span>
              <h2>FEMNITUDE'S SECRET SAUCE</h2>
              <span className="separator" />
              <p>
                Femnitude is a woman-owned company founded in May of 2019. The brand was created with all women in mind. Our mission is to bring awareness to women’s health while offering natural solutions that eliminate health complications among all women. We provide custom CBD subscription boxes that address a variety of gynecological issues many women face on an everyday basis. 
                <br/><br/>
                This auto-renewal service is designed for the woman on the go. We believe you should feel amazing while you tackle your everyday tasks!
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
    {/* +++ END - About +++ */}
    {/* +++ START - Services +++ */}
    <div className="section" id="section2">
      <section id="services" className="content-inside-section">
        <div className="row row-no-margin">
          <div className="left-center-text split-section">
            <div className="left-center-part">
              <span className="section-name">Alternative Solutions</span>
              <h2>Problems CBD can Help</h2>
              <span className="separator" />
              <p>
                We provide custom CBD subscription boxes that address a variety of gynecological issues many women face on an everyday basis. 
                Unlike THC, the chemical in marijuana responsible for the “high” CBD is a non-psychotropic derivative of the plant.
              </p>
              {/* +++ START - Carousel +++ */}
              <div id="carousel-services" className="carousel slide" data-interval={6000} data-ride="carousel">
                {/* Carousel indicators */}
                <ol className="carousel-indicators">
                  <li data-target="#carousel-services" data-slide-to={0} className="active" />
                  <li data-target="#carousel-services" data-slide-to={1} />
                  <li data-target="#carousel-services" data-slide-to={2} />
                </ol>   
                {/* START - Wrapper for carousel items */}
                <div className="carousel-inner">
                  {/* Services 1 */}
                  <div className="active item">
                    {/* START - Services row */}
                    <div className="row">
                      {/* START - Block services */}
                      <div className="col-xs-12 col-sm-6 col-lg-6 block-services">
                        <span className="icon-services"><FaFrownOpen/></span>
                        <h3>CBD &amp; Anxiety</h3>
                        <p>
                          Research has shown that CBD can help to relieve stress, anxiety, and depression by altering the brain's serotonin signals.
                          CBD also helps to relive social anxiety disorder (SAD) and post-traumatic stress disorder (PTSD).
                        </p>
                      </div> 
                      {/* END - Block services */}
                      {/* START - Block services */}
                      <div className="col-xs-12 col-sm-6 col-lg-6 block-services">
                        <span className="icon-services"><FaFemale/></span>
                        <h3>CBD &amp; Endometriosis</h3>
                        <p>
                          Cannabinoids could treat endometriosis by stopping cell proliferation, preventing cell migration, inhibiting lesion vascularization (blood vessels),
                          inhibiting lesion innervation, blocking synthesis of inflammatory prostaglandins, modulating the immune response,
                          and desensitizing nerves that transmit pain.
                        </p>
                      </div> {/* END - Block services */}
                    </div> {/* END - Services row */}
                  </div>
                  {/* Services 2 */}
                  <div className="item">
                    {/* START - Services row */}
                    <div className="row">
                      {/* START - Block services */}
                      <div className="col-xs-12 col-sm-6 col-lg-6 block-services">
                        <span className="icon-services" ><FaVaadin/></span>
                        <h3>CBD &amp; Menstrual Pain</h3>
                        <p>
                          CBD and other cannabinoids are incredibly effective at relieving menstrual cramps, 
                          and a large reason for this appears to be that CBD inhibits COX-2, 
                          the enzyme responsible for producing inflammatory prostaglandins.
                        </p>
                      </div> {/* END - Block services */}
                      {/* START - Block services */}
                      <div className="col-xs-12 col-sm-6 col-lg-6 block-services">
                        <span className="icon-services"><FaHeartbeat/></span>
                        <h3>CBD &amp; Inflammation</h3>
                        <p>
                          Cannabinoids are potent anti-inflammatory agents and they exert their effects through induction of apoptosis,
                          inhibition of cell proliferation, suppression of cytokine production and induction of T-regulatory cells.
                        </p>
                      </div> {/* END - Block services */}
                    </div> {/* END - Services row */}
                  </div>
                  {/* Services 3 */}
                  <div className="item">
                    {/* START - Services row */}
                    <div className="row">
                      {/* START - Block services */}
                      <div className="col-xs-12 col-sm-6 col-lg-6 block-services">
                        <span className="icon-services"><FaPlusSquare/></span>
                        <h3>CBD &amp; Uterine Fibroids</h3>
                        <p>
                          Published research suggests that cannabinoid compounds like CBD may be useful in treating uterine fibroids,
                          malignancies, and other hormone disorders by enhancing the endocannabinoid system. 
                        </p>
                      </div> {/* END - Block services */}
                      {/* START - Block services */}
                      <div className="col-xs-12 col-sm-6 col-lg-6 block-services">
                        <span className="icon-services"><FaPrescription/></span>
                        <h3>CBD &amp; Pain Relief</h3>
                        <p>
                          Studies have shown that CBD may help reduce chronic pain by impacting endocannabinoid receptor activity,
                          reducing inflammation and interacting with neurotransmitters 
                        </p>
                      </div> {/* END - Block services */}
                    </div> {/* END - Services row */}
                  </div>
                </div>
                {/* END - Wrapper for carousel items */}
                {/* Left arrow */}
                <a className="carousel-control left" href="#carousel-services" data-slide="prev">
                  <span className="icon-prev" />
                </a>
                {/* Right arrow */}
                <a className="carousel-control right" href="#carousel-services" data-slide="next">
                  <span className="icon-next" />
                </a>
              </div>
              {/* +++ END - Carousel +++ */}
            </div>
          </div>
        </div>
      </section>
    </div>
    {/* +++ END - Services +++ */}
    {/* +++ START - Portfolio +++ */}
    <div className="section" id="section3">
      <section id="portfolio" className="content-inside-section">
        <div className="split-section no-padding">
          <div className="portfolio my-gallery" itemScope itemType="http://schema.org/ImageGallery">
            {/* 1 */}
            <figure className="col-xs-6" itemProp="associatedMedia" itemScope itemType="http://schema.org/ImageObject">
              <a href="img/faith/1.png" className="gallery-link small" data-image="img/faith/1.png" itemProp="contentUrl" data-size="1920x1280">
                <img src="img/faith/1.png" itemProp="thumbnail" alt="This is my work" className="img-responsive gallery-img small-square" />
              </a>
              <figcaption itemProp="caption description">
                <div className="photo-details">
                  <h4><span>Body Scrub</span> - Lavender Body Scrub</h4>
                  <p>Our CBD Lavender Scrub will exfoliate your skin and leave you glowing. Our products are vegan and contain the best of organic ingredients.</p>
                </div>
              </figcaption>
            </figure>
            {/* 2 */}
            <figure className="col-xs-6" itemProp="associatedMedia" itemScope itemType="http://schema.org/ImageObject">
              <a href="img/faith/2.png" className="gallery-link small" data-image="img/faith/2.png" itemProp="contentUrl" data-size="1920x1280">
                <img src="img/faith/2.png" itemProp="thumbnail" alt="This is my work" className="img-responsive gallery-img small-square" />
              </a>
              <figcaption itemProp="caption description">
                <div className="photo-details">
                  <h4><span>CBD Lotion</span> - Pain Relief Lotion</h4>
                  <p>
                    This lotion has a base of organic aloe juice making it a water-based topical lotion.
                    It glides on your skin effortlessly and is absorbed immediately without an oily or sticky residue.
                    There is a cooling menthol, warming capsicum, and camphor oil for a cooling/warming sensation.
                    It’s then topped off with a complex blend of essential oils specifically engineered specifically for relief.
                    As it glides on, it won’t leave any greasy residue and will absorb right into the dermis of the skin and into the bloodstream.
                    The nanoparticles will interact with the endocannabinoid system much quicker than traditional CBD oil.</p>
                </div>
              </figcaption>
            </figure>
            {/* 3 */}
            <figure className="col-xs-6" itemProp="associatedMedia" itemScope itemType="http://schema.org/ImageObject">
              <a href="img/faith/3.png" className="gallery-link small" data-image="img/faith/3.png" itemProp="contentUrl" data-size="1920x1280">
                <img src="img/faith/3.png" itemProp="thumbnail" alt="This is my work" className="img-responsive gallery-img small-square" />
              </a>
              <figcaption itemProp="caption description">
                <div className="photo-details">
                  <h4><span>CBD Body Wash</span> - Topical CBD Gel</h4>
                  <p>
                    Your skin is your largest organ and provides the largest surface area for cannabinoid exposure. The CBD particles fully absorb directly into the bloodstream for the most bioavailable CBD experience. This CBD gel works as a body wash, shampoo, and face wash, combining hints of citrus, pink grapefruit, lemon, lime, and mandarin.
                    <br/><br/>
                    We at Femnitude understand that not everyone has time or access to a bath. So, we wanted to offer a product for daily use that could help with a wide variety of benefits. It’s important to lather up with this product to allow for the full absorption of the cannabinoids.
                  </p>
                </div>
              </figcaption>
            </figure>
            {/* 4 */}
            <figure className="col-xs-6" itemProp="associatedMedia" itemScope itemType="http://schema.org/ImageObject">
              <a href="img/faith/4.png" className="gallery-link small" data-image="img/faith/4.png" itemProp="contentUrl" data-size="1920x1280">
                <img src="img/faith/4.png" itemProp="thumbnail" alt="This is my work" className="img-responsive gallery-img small-square" />
              </a>
              <figcaption itemProp="caption description">
                <div className="photo-details">
                  <h4><span>CBD Tincture</span> - Gluten-Free</h4>
                  <p>
                    This is an oral application of CBD oil which is a great way to incorporate CBD into your daily routine. Much like taking a multivitamin daily, Femnitude’s CBD oil has benefits not just through topical application, but also by fully ingesting the CBD you can maximize the exposure.
                    <br/><br/>
                    This ultra-versatile pure CBD tincture provides 500mg of high-quality, full-spectrum hemp CBD. You can also add these CBD drops to their favorite smoothies, soups, sauces and baked goods for a tastier dose of CBD.
                  </p>
                </div>
              </figcaption>
            </figure>
            {/* 5 */}
            <figure className="col-xs-6" itemProp="associatedMedia" itemScope itemType="http://schema.org/ImageObject">
              <a href="img/faith/5.png" className="gallery-link small" data-image="img/faith/5.png" itemProp="contentUrl" data-size="1920x1280">
                <img src="img/faith/5.png" itemProp="thumbnail" alt="This is my work" className="img-responsive gallery-img small-square" />
              </a>
              <figcaption itemProp="caption description">
                <div className="photo-details">
                  <h4><span>CBD Gummies</span> - Edible CBD</h4>
                  <p>
                    This is no ordinary CBD gummy. Our gummies are the highest quality USA-grown and extracted full-spectrum hemp extract and take the utmost care to ensure consistent, accurate dosing that you can feel.
                    <br/><br/>
                    CBD with delicious flavor &amp; gourmet chew that you expect from a world-class gummy. We know you will enjoy them as much as we do!
                  </p>
                </div>
              </figcaption>
            </figure>
            {/* 6 */}
            <figure className="col-xs-6" itemProp="associatedMedia" itemScope itemType="http://schema.org/ImageObject">
              <a href="img/faith/6.png" className="gallery-link small" data-image="img/faith/6.png" itemProp="contentUrl" data-size="1920x1280">
                <img src="img/faith/6.png" itemProp="thumbnail" alt="This is my work" className="img-responsive gallery-img small-square" />
              </a>
              <figcaption itemProp="caption description">
                <div className="photo-details">
                  <h4><span>CBD Bath Bomb</span> - Relaxing</h4>
                  <p>
                    Your skin is your largest organ and is a powerful tool for absorbing cannabinoids and balancing your endocannabinoid system. As you soak in the tub, your body absorbs the essential oils and the CBD, like a sponge. A cannabis bath bomb is a full-body topical application that allows for unparalleled all-over relief. These powerful molecules work together with your endocannabinoid system creating a synergistic effect.
                  </p>
                </div>
              </figcaption>
            </figure>
          </div>
        </div>
      </section>
    </div>
    {/* +++ END - Portfolio +++ */}
    {/* +++ START - Team +++ */}
    <div className="section" id="section4">
      <section id="team" className="content-inside-section">
        <div className="row row-no-margin">
          <div className="left-center-text split-section">
            <div className="left-center-part">
              <span className="section-name">Our Team</span>
              <h2>Who Makes Femnitude Happen</h2>
              <span className="separator" />
              {/* START - Team */}
              <div className="row">
                {/* 1 */}
                <div className="col-xs-12 col-sm-6 col-lg-4 block-team">
                  <ul className="social-team">
                    {/* Facebook */}
                    <li>
                      <a href="https://www.facebook.com/nlamaratty"><i className="fa fa-facebook" /></a>
                    </li>
                    {/* Linkedin */}
                    <li>
                      <a href="https://www.linkedin.com/in/nikita-lamar-j-d-58918384/"><i className="fa fa-linkedin" /></a>
                    </li>
                  </ul>
                  <img src="img/nikita-cropped.jpg" alt="Member 2" className="img-responsive team-member" />
                  <h3>Nikita Lamar <small>President/CEO</small></h3>
                  <p>
                  Nikita Lamar is the Founder of Femnitude, LLC. Nikita holds cannabis and CBD certifications from Green Flower a leader in cannabis education. Her goal for Femnitude is to create a community among women interested in the CBD alternatives to over the counter and prescribed medications.
                  </p>
                </div>
                <div className="col-xs-12 col-sm-6 col-lg-4 block-team">
                  <ul className="social-team">
                    {/* Facebook */}
                    <li>
                      <a href="https://www.facebook.com/faith.howard.7777019"><i className="fa fa-facebook" /></a>
                    </li>
                    {/* Twitter */}
                    <li>
                      <a href="https://twitter.com/_MissHoward_"><i className="fa fa-twitter" /></a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/in/faith-howard-26169712a/"><i className="fa fa-linkedin" /></a>
                    </li>
                  </ul>
                  <img src="https://media.licdn.com/dms/image/C4E03AQEW25c1P_mbgQ/profile-displayphoto-shrink_800_800/0?e=1573084800&v=beta&t=ifFkfqHMih57mBcbcYB1k6UjZRmzRpBS5lbKH975PGM" alt="Member 1" className="img-responsive team-member" />
                  <h3>Faith Howard<small>Marketing Coordinator</small></h3>
                  <p>
                    Faith Howard is a marketing professional that specializes in brand awareness and is privileged in assisting several organizations
                    and companies in growing their online audience through the use of social media, email campaigns, and engaging website design.
                  </p>
                </div>
                {/* 2 */}
                <div className="col-xs-12 col-sm-6 col-lg-4 block-team">
                  <ul className="social-team">
                    {/* Facebook */}
                    <li>
                      <a href="https://www.facebook.com/clickficks/"><i className="fa fa-facebook" /></a>
                    </li>
                    {/* Twitter */}
                    <li>
                      <a href="https://twitter.com/clickficks_"><i className="fa fa-twitter" /></a>
                    </li>
                    {/* Linkedin */}
                    <li>
                      <a href="https://www.linkedin.com/in/tyler-c-435455b8/"><i className="fa fa-linkedin" /></a>
                    </li>
                  </ul>
                  <img src="https://scontent-dfw5-2.xx.fbcdn.net/v/t1.0-9/56510907_10210439779590624_6783620464271949824_n.jpg?_nc_cat=108&_nc_oc=AQlB5FuYSb_HpgiAJZ-c73msvr4GYpcDPmsgLdvnB5zgDOeWIKu5PqKBz142ZHq-5Y0&_nc_ht=scontent-dfw5-2.xx&oh=4b8d41f8aa473f65ca83d6f27d45510d&oe=5DBD631A" alt="Member 2" className="img-responsive team-member" />
                  <h3>Tyler Clay <small>Web Developer</small></h3>
                  <p>
                    Tyler Clay is an experienced web developer and marketing professional. 
                    His company, Clickficks Software &amp; Marketing, was selected to digitize the Femnitude movement and bring CBD awareness to women worldwide. 
                  </p>
                </div>
              </div>
              {/* END - Team */}
            </div>	
          </div>
        </div>
      </section>
    </div>
    {/* +++ END - Team +++ */}
    {/* +++ START - Contact +++ */}
    <div className="section" id="section5">
      <section id="contact" className="content-inside-section">
        <div className="row row-no-margin">
          <div className="left-center-text split-section">
            <div className="left-center-part">
              <span className="section-name">Enter Our Giveaway</span>
              <h2>Win a 3 Month Subscription!</h2>
              <span className="separator" />
              <p className="subtitle">Please fill out this short form to be entered into our 3 month small box giveaway!<br />
                Contact us via <strong>Email</strong> at <a href="mailto:femnitude@gmail.com" className="phone-mail-link">femnitude@gmail.com</a> for any questions or concerns!</p>
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-lg-12">
                  {/* START - Contact Form */}
                    <div className="row">
                      {/* ! Anti-spam field ! Invisible for users, the major part of bots will write something in this field, then, they will be blocked and no spam in your inbox will come.  */}
                      <div className="col-xs-12 col-sm-12 col-lg-12 display-none">
                        <div className="form-group">
                          <input type="text" id="checking" className="form form-control" placeholder="Leave this field empty" name="checking" data-name="Checking" />
                        </div>
                      </div>
                      {/* Full name */}
                      <div className="col-xs-12 col-sm-6 col-lg-6">
                        <div className="form-group">
                          <input type="text" id="name" className="form form-control" placeholder="Name*"  name="name" data-name="Name" required onChange={this.handleChange}/>
                        </div>
                      </div>
                      {/* E-mail */}
                      <div className="col-xs-12 col-sm-6 col-lg-6">
                        <div className="form-group">
                          <input type="email" id="email" className="form form-control" placeholder="Email Address*" name="email-address" data-name="Email Address" required onChange={this.handleChange} />
                        </div>
                      </div>
                     
                      {/* Phone */}
                      <div className="col-xs-12 col-sm-12 col-lg-12">
                        <div className="form-group">
                          <input type="tel" id="phone" className="form form-control" placeholder="Phone number*"  name="phone" data-name="Phone" required onChange={this.handleChange} />
                        </div>
                      </div>
                      {/* Message */}
                      <div className="col-xs-12 col-sm-12 col-lg-12">
                        <div className="form-group">
                          <textarea id="message" className="form textarea form-control" placeholder="Please enter any information to help us understand your needs..."  name="message" data-name="Text Area"  defaultValue={""} onChange={this.handleChange} />
                        </div>
                      </div>
                   
                        <div className={`${classes.tileGroup}`}>
                          <div className={`${this.state.problems['anxiety'] ? classes.selectedTile : classes.tile} col-xs-3 col-sm-2 col-lg-2`} onClick={this.handleTileClick} id='anxiety'>
                            <span className={classes.tileIcon}>
                              <FaFrownOpen/>
                            </span><br/>
                            <span className={classes.tileName}>
                              Anxiety
                            </span>
                          </div>
                          <div className={`${this.state.problems['endometriosis'] ? classes.selectedTile : classes.tile} col-xs-3 col-sm-3 col-lg-2`} onClick={this.handleTileClick} id='endometriosis'> 
                            <span className={classes.tileIcon}>
                              <FaFemale/>
                            </span><br/>
                            <span className={classes.tileName}>
                              Endometriosis
                            </span>
                          </div>
                          <div className={`${this.state.problems['menstrual-pain'] ? classes.selectedTile : classes.tile} col-xs-3 col-sm-3 col-lg-2`} onClick={this.handleTileClick} id='menstrual-pain'>
                            <span className={classes.tileIcon}>
                              <FaVaadin/>
                            </span><br/>
                            <span className={classes.tileName}>
                              Menstrual Pain
                            </span>
                          </div>
                          <div className={`${this.state.problems['inflammation'] ? classes.selectedTile : classes.tile} col-xs-3 col-sm-3 col-lg-2`} onClick={this.handleTileClick} id='inflammation'>
                            <span className={classes.tileIcon}>
                              <FaHeartbeat/>
                            </span><br/>
                            <span className={classes.tileName}>
                              Inflammation
                            </span>
                          </div>
                          <div className={`${this.state.problems['uterine-fibroids'] ? classes.selectedTile : classes.tile} col-xs-3 col-sm-3 col-lg-2`} onClick={this.handleTileClick} id='uterine-fibroids'>
                            <span className={classes.tileIcon}>
                              <FaPlusSquare/>
                            </span><br/>
                            <span className={classes.tileName}>
                              Uterine Fibroids
                            </span>
                          </div>
                          <div className={`${this.state.problems['pain-relief'] ? classes.selectedTile : classes.tile} col-xs-3 col-sm-3 col-lg-2`} onClick={this.handleTileClick} id='pain-relief'>
                            <span className={classes.tileIcon}>
                              <FaPrescription/>
                            </span><br/>
                            <span className={classes.tileName}>
                              Pain Relief
                            </span>
                          </div>
                        </div>
                      
                      
                    </div>
                    {/* Form submission */}
                    
                    <button type="button" id="valid-form" className="btn btn-lg submit" onClick={this.enterGiveaway}>Enter Giveaway</button>
                    <br/><br/><br/>
                    {this.state.postSuccess ?
                      <span style={{color: 'green'}}>
                        Thank you for entering our giveaway! The last step to enter is liking our 
                        <a href='https://www.facebook.com/Femnitude/' style={{color: '#E02A78'}}> Facebook </a> 
                        and <a href='https://www.instagram.com/femnitude/' style={{color: '#E02A78'}}> Instagram</a> pages! Thank you for choosing Femnitude!
                      </span> : <span/>
                    }
                    <br/>
                    {this.state.postFailure ? 
                      <span style={{color: 'red'}}>
                        Sorry we were unable to post your request to enter the giveaway! Please send an email to femnitude@gmail.com to enter the giveaway! Thank you for choosing Femnitude!
                      </span> : <span/>
                    }
                  {/* END - Contact Form */}
                </div>
              </div>
             
            </div>	
          </div>
        </div>
      </section>
    </div>
    {/* +++ END - Contact +++ */}
  </div>
  {/* +++ / Fullpage sections +++ */}
  {/* CONTACT FORM - Answer for the contact form is displayed in the next div, do not remove it. */}       
  <div id="block-answer">
    <div id="answer" />
  </div>
  {/* NEWSLETTER FORM - Answer for the newsletter form is displayed in the next div, do not remove it. */}
  <div className="block-message">
    <div className="message">
      <p className="notify-valid" />
    </div>
  </div>
  {/* DO NOT REMOVE THE FOLLOWING DIV IF YOU'RE USING THE PHOTOS GALLERY */}
  <div id="photoswipe" />
  
</div>

    </div>
  );
}
}

export default withStyles(styles)(App)
